<app-service-state-form 
    [title]="'pages.services-state.configuration.create.header.title' | translate"
    [submitLoading]="loading"
    (submitForm)="handleSubmit($event)">
</app-service-state-form>
